module.exports = __webpack_public_path__ + "img/2.3a6dd1c8.png";